var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"notification",style:(_vm.style)},[_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm.content))]),_c('a',{staticClass:"btn",on:{"click":_vm.handleClose}},[_vm._v(_vm._s(_vm.btn))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }